exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-header-close-icon-1yVyKavKmwr{margin-left:8px}.page-header-secondary-nav-button-3gyIeCA2mwr{padding:4px 8px 4px 4px;font-size:14px;line-height:20px;font-weight:600 !important;align-self:center}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"close-icon": "page-header-close-icon-1yVyKavKmwr",
	"closeIcon": "page-header-close-icon-1yVyKavKmwr",
	"secondary-nav-button": "page-header-secondary-nav-button-3gyIeCA2mwr",
	"secondaryNavButton": "page-header-secondary-nav-button-3gyIeCA2mwr"
};